module.exports = __webpack_public_path__ + "static/media/jinrong.cd4667d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageCommercialPassword/jinrong.png
// module id = 609
// module chunks = 0